import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditRetailProduct = () => {
  const navigate = useNavigate();
  const { product_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [products, setProducts] = useState({
    product_code: "",
    product_name: "",
    unit: "",
    box_content: "",
    rate_per: "",
    //stock: "",
    tax: "",
    supplier_id: "",
    supplier_name: "",

  });

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [selectedsupplier, setSelectedSupplier] = useState("");



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}retail_product_detail.php`,
          { product_id }
        );

        if (response.data && response.data.body) {
          const productData = response.data.body;
          setProducts(productData);
          setSelectedCategory(productData.category_id);
          setSelectedBrand(productData.brand_id);
          setSelectedSupplier(productData.supplier_id);
        } else {
          setError("No data found");
        }
      } catch (error) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();

    axios
      .post(`${API_BASE_URL}category_list.php`)
      .then((res) => setCategories(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
    axios
      .post(`${API_BASE_URL}supplier_list.php`)
      .then((res) => setSupplier(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
    axios
      .post(`${API_BASE_URL}brand_list.php`)
      .then((res) => setBrands(res.data.body || []))
      .catch((err) => console.error("Brand fetch error:", err));
  }, [product_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProducts((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${API_BASE_URL}retail_product_detail_update.php`,
        { product_id, ...products }
      );

      if (response.data.head.code === 200) {
        alert("Product updated successfully!");
        navigate("/retailproduct");
      } else {
        alert("Update failed: " + response.data.head.msg);
      }
    } catch (error) {
      alert("Failed to update product.");
    }
  };

  if (loading) return <p> </p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="title-header option-title d-sm-flex d-block">
                        <h5>Edit Retail Product</h5>
                        <div className="right-options">
                          <ul>
                            <li>
                              <Link
                                className="btn btn-solid"
                                onClick={() => window.history.back()}
                              >
                                Back
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <form className="theme-form theme-form-2 mega-form" onSubmit={handleUpdate}>
                        <div className="row">
                          {/* Product Code */}
                          {/* <div className="col-md-6">
                                      <div className="mb-4">
                                        <label>Product Code</label>
                                        <input
                                          className="form-control"
                                          name="product_code"
                                          type="text"
                                          placeholder="Enter Product Code"
                                          value={products.product_code || ""}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div> */}

                          {/* Product Name */}
                          <div className="col-md-6">
                            <div className="mb-4">
                              <label>Product Name</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="product_name"
                                placeholder="Enter Product Name"
                                value={products.product_name || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                           <div className="col-md-6 col-sm-6">
                            <div className="mb-4">
                              <label>Rate</label>
                               <div className="d-flex">
                              <input
                                className="form-control"
                                type="text"
                                name="rate"
                                placeholder="Enter Rate"
                                value={products.rate || ""}
                                onChange={handleInputChange}
                              />
                              
                                </div>
                            </div>
                          </div>

                          {/* First row with four columns */}
                          <div className="col-md-6">
                            <div className="mb-4">
                              <label>Qty Per Box</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="qty_per_box"
                                placeholder="Enter Qty Per Box"
                                value={products.qty_per_box || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>







                          {/* Second row with four columns */}
                         

                          <div className="col-md-6 col-sm-6">
                            <div className="mb-4">
                              <label>Stock</label>
                              <input
                                className="form-control"
                                type="text"
                                name="stock"
                                placeholder="Enter Stock"
                                value={products.stock || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          

                        </div>

                        {/* Submit and Cancel Buttons */}
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-primary me-3" type="submit">
                            Submit
                          </button>
                          <button
                            className="btn btn-outline"
                            type="button"
                            onClick={() => window.history.back()}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRetailProduct;
